import * as faceapi from 'face-api.js';

// Primary and backup CDN URLs for models
const PRIMARY_MODEL_URL = 'https://justadudewhohacks.github.io/face-api.js/models';
const BACKUP_MODEL_URL = 'https://cdn.jsdelivr.net/gh/justadudewhohacks/face-api.js@master/weights';

// Function to load models from URL instead of local path
export const loadModelsFromUri = async () => {
  try {
    console.log('Loading face-api.js models from primary CDN...');
    
    // Try loading from primary CDN
    try {
      await Promise.all([
        faceapi.nets.ssdMobilenetv1.loadFromUri(PRIMARY_MODEL_URL),
        faceapi.nets.faceLandmark68Net.loadFromUri(PRIMARY_MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(PRIMARY_MODEL_URL)
      ]);
      
      console.log('All models loaded successfully from primary CDN');
      return { success: true, message: 'Face models loaded successfully' };
    } catch (primaryError) {
      console.warn('Failed to load from primary CDN, trying backup...', primaryError);
      
      // Try loading from backup CDN
      await Promise.all([
        faceapi.nets.ssdMobilenetv1.loadFromUri(BACKUP_MODEL_URL),
        faceapi.nets.faceLandmark68Net.loadFromUri(BACKUP_MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(BACKUP_MODEL_URL)
      ]);
      
      console.log('All models loaded successfully from backup CDN');
      return { success: true, message: 'Face models loaded successfully (backup source)' };
    }
  } catch (error) {
    console.error('Error loading models from all sources:', error);
    return { success: false, message: 'Failed to load face models: ' + error.message };
  }
};

// Check if models are loaded
export const areModelsLoaded = () => {
  return (
    faceapi.nets.ssdMobilenetv1.isLoaded &&
    faceapi.nets.faceLandmark68Net.isLoaded &&
    faceapi.nets.faceRecognitionNet.isLoaded
  );
};

// Force unload all models (useful for testing and troubleshooting)
export const unloadModels = () => {
  try {
    if (faceapi.nets.ssdMobilenetv1.isLoaded) {
      faceapi.nets.ssdMobilenetv1.dispose();
    }
    if (faceapi.nets.faceLandmark68Net.isLoaded) {
      faceapi.nets.faceLandmark68Net.dispose();
    }
    if (faceapi.nets.faceRecognitionNet.isLoaded) {
      faceapi.nets.faceRecognitionNet.dispose();
    }
    return true;
  } catch (error) {
    console.error('Error unloading models:', error);
    return false;
  }
}; 